import React from 'react';
import { Navbar, Container, Button } from 'react-bootstrap';

function Header({ refreshEmails }) {
  return (
    <Navbar bg="primary" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand>
          <i className="bi bi-envelope-fill me-2"></i>
          Cloudflare Mailbox
        </Navbar.Brand>
        <Button 
          variant="outline-light" 
          size="sm" 
          onClick={refreshEmails}
        >
          <i className="bi bi-arrow-clockwise me-1"></i>
          Refresh
        </Button>
      </Container>
    </Navbar>
  );
}

export default Header;
